import { render, staticRenderFns } from "./AlertAccordion.vue?vue&type=template&id=0652bc2c&"
import script from "./AlertAccordion.vue?vue&type=script&lang=ts&"
export * from "./AlertAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./AlertAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
